import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import * as Sentry from '@sentry/react';

import App from './App.tsx';
import './index.css';
import { initClarity } from './services/clarityService';
import { initSentry } from './services/sentryService';

// Initialize Microsoft Clarity for user session analytics on app boot.
initClarity();
// Initialize Sentry for error tracking & performance monitoring on app boot.
initSentry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div>Something went wrong.</div>}>
      <DndProvider backend={HTML5Backend}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <App />
        </LocalizationProvider>
      </DndProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
